export default class Header {
  constructor() {
    this.header = '#header'
    this.$header = $(this.header)
    this.numberScroll = 0
    this.scrollTop = 0
    this.class = 'pin-header'

    this.scrollHideClass = 'scroll-down'
    this.lastScrollY = 0
    this.ticking = false
  }

  init() {
    if (this.$header.length) {
      this.scrollPinHeader()
    }
  }

  scrollPinHeader() {
    this.lastScrollY = $(window).scrollTop()
    this.settingPin()
    this.setHeaderHeight()

    $(window).on('scroll', () => {
      this.onScroll()
    })

    $(window).on('resize orientationchange', () => {
      this.settingPin()
      this.setHeaderHeight()
      this.resetScrollHide()
    })
  }

  onScroll() {
    if (this.ticking) return
    this.ticking = true
    requestAnimationFrame(() => {
      this.settingPin()
      this.setHeaderHeight()
      this.settingScrollHide()
      this.ticking = false
    })
  }

  settingPin() {
    this.scrollTop = $(window).scrollTop()
    if (this.scrollTop > this.numberScroll) {
      this.$header.addClass(this.class)
    } else {
      this.$header.removeClass(this.class)
    }
  }

  settingScrollHide() {
    const currentY = $(window).scrollTop()
    const delta = currentY - this.lastScrollY

    if (this.$header.hasClass('is-open-menu') || $('body').hasClass('search-lightbox-open')) {
      this.lastScrollY = currentY
      return
    }

    const headerHeight = this.$header.outerHeight() || 0
    if (currentY <= headerHeight) {
      this.resetScrollHide()
      this.lastScrollY = currentY
      return
    }

    if (Math.abs(delta) < 5) return

    if (delta > 0) {
      this.$header.addClass(this.scrollHideClass)
    } else {
      this.$header.removeClass(this.scrollHideClass)
    }

    this.lastScrollY = currentY
  }

  resetScrollHide() {
    this.$header.removeClass(this.scrollHideClass)
    this.lastScrollY = $(window).scrollTop()
  }

  setHeaderHeight() {
    if (this.$header.length) {
      const height = this.$header.outerHeight()
      document.documentElement.style.setProperty('--header-height', `${height}px`)
    }
  }
}

new Header().init()
